// src/components/connexion/QuiUtiliseLaTablette.tsx — SCE Issues
// « Qui utilise la tablette ? » — posée une fois, sur un appareil partagé (07/10).
//
// L'iPad de l'atelier Elec / Autom n'a qu'un compte pour Thibaut et Hugo
// (config/comptesAlias.config, comptesPartages()). Tant que l'appareil ne sait
// pas qui le tient, l'appli ne se monte pas : sans personne, le compte invité
// passerait pour un fournisseur. Le choix est retenu sur l'appareil
// (auth/comptePartage) ; on change ensuite dans le menu du compte.
//
// Pour tout autre compte, la garde rend ses enfants sans rien faire.

import { useState, type JSX, type ReactNode } from 'react'
import { ArrowRight } from 'lucide-react'
import { useAuth } from '@/auth/useAuth'
import { identiteDuCompte, partageDuCompte } from '@/auth/identiteCompte'
import { noterAppareilPartage, retenirPersonne } from '@/auth/comptePartage'
import { PastillePersonne } from '@/components/personnes/PastillePersonne'
import { LogoSartorius } from '@/components/ui/Marque'
import { nomComplet } from '@/utils/noms'

export function GardeComptePartage({ children }: { children: ReactNode }): JSX.Element {
  const { account } = useAuth()
  // Relu à chaque rendu : la réponse est dans le localStorage, ce compteur
  // ne sert qu'à faire rendre la garde une fois la personne retenue.
  const [, setReponses] = useState(0)

  const partage = partageDuCompte(account)
  // Noté pour les API : elles signent leurs créations (colonne SaisiPar).
  noterAppareilPartage(partage?.objectId ?? null)
  if (!partage || identiteDuCompte(account)) return <>{children}</>

  return (
    <main
      className="flex flex-col items-center justify-center"
      style={{
        minHeight: '100dvh',
        boxSizing: 'border-box',
        padding: '40px 16px calc(28px + env(safe-area-inset-bottom, 0px))',
        background: 'var(--color-white)',
      }}
    >
      <div className="flex flex-col connexion-entree" style={{ width: '100%', maxWidth: 440, gap: 32 }}>
        <div className="flex flex-col" style={{ gap: 14 }}>
          <div className="flex items-center" style={{ gap: 10 }}>
            <LogoSartorius hauteur={16} />
            <span style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>
              {partage.libelle}
            </span>
          </div>
          <h1 style={{ margin: 0, fontSize: 36, lineHeight: '42px', fontWeight: 300 }}>
            Qui utilise la tablette&nbsp;?
          </h1>
          <p style={{ margin: 0, fontSize: 16, lineHeight: '23px', color: 'var(--color-text-secondary)' }}>
            Vos droits, vos suivis et vos réglages s’ouvrent à votre nom. Retenu sur la
            tablette&nbsp;: changez dans le menu du compte, en haut à droite.
          </p>
        </div>

        <div className="flex flex-col" style={{ gap: 12 }}>
          {partage.personnes.map((p) => (
            <button
              key={p.upn}
              type="button"
              className="tablette-personne"
              onClick={() => {
                retenirPersonne(partage.objectId, p.upn)
                setReponses((n) => n + 1)
              }}
            >
              <PastillePersonne nom={nomComplet(p.nom)} upn={p.upn} taille={48} />
              <span style={{ flex: 1, textAlign: 'left' }}>{nomComplet(p.nom)}</span>
              <ArrowRight size={20} strokeWidth={2} aria-hidden="true" />
            </button>
          ))}
        </div>
      </div>
    </main>
  )
}
